import React, { useEffect, useState, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Formio } from "react-formio";
import { callEndpoint } from "../ApiCall";
import LogoImage from "../images/logo.png";
import NoDataImage from "../images/no-results.jpg";
import "../styles.css";
import Footer from "../inc/footer";
// TEMPORARILY DISABLED: import useIframeAuth from "../hooks/useIframeAuth";

export const Fetch = (id) => {
  const body = {
    col: ["name","data"],
    filter: [
      ["park", "=", "0"],
      ["id", "=", id],
    ],
    table: "form",
  };
  const endpoint = "settingRoute.php";
  const action = "getSetting";

  return callEndpoint(body, endpoint, action);
};

const Submission = () => {
  // TEMPORARILY DISABLED: const { isAuthorized, isChecking } = useIframeAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [noData, setNoData] = useState(false);
  var [heading, setHeading] = useState("");
  const history = useHistory();
  const isFirstFetch = useRef(true); // Prevent double Fetch calls

  const params = new URLSearchParams(window.location.search);

  const saveFormData = useCallback(
    (components, submissionData) => {
      const assignmentId = params.get("assignment_id") || "" ;
      const tcid = params.get("tcid") || 0; 
      const batchsche_id = params.get("batchsche_id") || 0 ;
      const training_no = params.get("training_no") || 0;
      const formId = params.get("fid") || "";
      
      const combinedData = {
        components,
        submission: submissionData,
      };

      var body = {
        form_token: "ABCD12345678",
        assignment_id: assignmentId,
        form_data: combinedData,
        contact_id: tcid,
        batchsche_id: batchsche_id,
        training_no: training_no,
        form_id: formId,
        form_type : 1
      };

      const endpoint = "formRoute.php";
      const action = "insert_form_data";

      callEndpoint(body, endpoint, action)
        .then(() => {
          history.push("/thankyou");
        })
        .catch((err) => {
          console.error("Error submitting form:", err);
          alert("Failed to submit the form. Please try again.");
        });
    },
    [params, history]
  );
    
  useEffect(() => {
    if (isFirstFetch.current) {
      isFirstFetch.current = false; // Mark as processed
      const fid = params.get("fid");
      if (fid) {
        Fetch(fid)
          .then((data) => {
            setLoading(false);

            if (data && data.data && data.data.length > 0) {
              setHeading(data.data[0].name);
              const parsedData = JSON.parse(data.data[0].data);
              Formio.createForm(document.getElementById("formio-result"), {
                components: parsedData,
              }).then((form) => {
                // 🎯 Intercept clicks on S3 links and open video modal
                const formContainer = document.getElementById("formio-result");
                if (formContainer) {
                  formContainer.addEventListener(
                    'click',
                    (e) => {
                      const link = e.target.closest('a');
                      if (!link) return;

                      const href = link.getAttribute('href');
                      if (!href) return;

                      // Check if this is an S3/AWS link
                      if (href.includes('amazonaws.com') || href.includes('s3') || href.endsWith('.mp4')) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        
                        console.log('Opening video modal for:', href);
                        
                        // Extract file info and open video modal
                        const fileName = link.textContent || href.split('/').pop() || 'video.mp4';
                        const isVideo = href.endsWith('.mp4') || href.endsWith('.webm') || href.endsWith('.mov');
                        const isImage = href.endsWith('.jpg') || href.endsWith('.jpeg') || href.endsWith('.png') || href.endsWith('.gif');
                        
                        // Determine file type
                        let fileType = 'application/octet-stream';
                        if (isVideo) fileType = 'video/mp4';
                        else if (isImage) fileType = 'image/jpeg';
                        
                        // Extract key from URL
                        let s3Key = '';
                        try {
                          const urlObj = new URL(href);
                          s3Key = urlObj.pathname.substring(1); // Remove leading slash
                        } catch (err) {
                          s3Key = href.split('.amazonaws.com/')[1] || '';
                        }
                        
                        // Build file object that matches what s3.js expects
                        const fileObj = {
                          name: fileName,
                          url: href,
                          key: s3Key,
                          type: fileType,
                          storage: 's3'
                        };
                        
                        // Get S3 provider and call downloadFile
                        const s3Provider = Formio.Providers.getProvider('storage', 's3');
                        if (s3Provider) {
                          const provider = s3Provider(Formio);
                          provider.downloadFile(fileObj);
                        } else {
                          console.error('S3 storage provider not found');
                        }
                      }
                    },
                    true // capture phase
                  );
                }

                form.on("submit", (submission) => {
                  saveFormData(parsedData, submission.data);
                });
              });
            } else {
              setNoData(true);
            }
          })
          .catch((err) => {
            setLoading(false);
            setError("Error fetching data.");
            console.error(err);
          });
      } else {
        setLoading(false);
        setNoData(true);
      }
    }
  }, [params, saveFormData]);

  /* TEMPORARILY DISABLED: iframe auth check
  // Show loader while checking iframe auth
  if (isChecking) {
    return (
      <div className="app-container">
        <div id="loader" className="loader"></div>
      </div>
    );
  }

  // If not authorized, component will redirect (handled by hook)
  if (!isAuthorized) {
    return null;
  }
  */

  return (
    <div className="app-container">
      <div>
        <img className="topCenter" src={LogoImage} alt="logo" />
      </div>
      <div>
        {loading && <div id="loader" className="loader"></div>}
        {!loading && noData && (
          <div className="no-data-container">
            <img src={NoDataImage} alt="No Data" className="no-data-image" />
            <h2>No Data Found</h2>
          </div>
        )}
        {!loading && error && (
          <div className="no-data-container">
            <img src={NoDataImage} alt="Error" className="no-data-image" />
            <h2>Error Fetching Data</h2>
            <p>Something went wrong. Please try again later.</p>
          </div>
        )}
        {!loading && !noData && !error && (
          <div>
            <h3>{heading}</h3>
            <div
              id="formio-result" className="app-content"
              style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Submission;
